import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../redux/ApplicationState";
import { getConfigs } from "../../actions/AppConfigs";
import Header from "../components/Header";
import { getPortalUpdate } from "../../actions/AdminActions";
import { getNotificationsList, postViewedNotificationDetails } from "../../actions/ReferralAction";
import { ViewedNotificationDetails } from "../../models/Referral";
import { logoutPortalApp } from "../../actions/UserAction";

const mapStateToProps = ({
  appConfigsState,
  loggedInUserState,
  getPortalUpdateState,
  headerNotificationListState,
  downloadDocumentOfNotificationState,
  userLogoutState
}: ApplicationState) => ({
  config: appConfigsState.response,
  loggedInUser: loggedInUserState,
  portalUpdateState: getPortalUpdateState.response,
  headerNotificationListState: headerNotificationListState.response,
  downloadDocumentOfNotificationState: downloadDocumentOfNotificationState,
  userLogoutState: userLogoutState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    getConfig: (file: string) => {
      dispatch(getConfigs(file));
    },
    getPortalUpdate: () => {
      dispatch(getPortalUpdate());
    },
    getNotificationsList: (userId: string) => {
      dispatch(getNotificationsList(userId));
    },
    postViewedNotificationDetails: (payload: ViewedNotificationDetails) => {
      dispatch(postViewedNotificationDetails(payload));
    },
    logoutPortalApp: () => {
      dispatch(logoutPortalApp());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
